import { useEffect, useRef } from 'react';
import styles from './Turnstile.module.css';

const SCRIPT_SRC =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let scriptPromise;

const loadTurnstile = () => {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = SCRIPT_SRC;
      script.async = true;
      script.onload = () => resolve(window.turnstile);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
};

// Remount (change `key`) to get a fresh token; tokens are single-use.
export const Turnstile = ({ action, onToken }) => {
  const ref = useRef(null);

  useEffect(() => {
    let widgetId;
    loadTurnstile()
      .then((turnstile) => {
        if (!ref.current) return;
        widgetId = turnstile.render(ref.current, {
          sitekey: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
          action,
          language: 'nl',
          callback: (token) => onToken(token),
          'expired-callback': () => onToken(null),
          'error-callback': () => onToken(null),
        });
      })
      .catch(console.error);

    return () => {
      if (widgetId !== undefined) window.turnstile?.remove(widgetId);
    };
  }, [action, onToken]);

  return <div ref={ref} className={styles.turnstile} />;
};
